/* eslint-disable react/prop-types */
import {
  createStyles,
  // Menu,
  // Center,
  Header,
  Container,
  // Group,
  // Button,
  // Burger,
} from "@mantine/core";
import Login from "./OTPRollNoModal";
import { fetchUserApi } from "../../api/user";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const HEADER_HEIGHT = 60;

const useStyles = createStyles((theme) => ({
  inner: {
    height: HEADER_HEIGHT,
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },

  links: {
    [theme.fn.smallerThan("sm")]: {
      display: "none",
    },
  },

  burger: {
    [theme.fn.largerThan("sm")]: {
      display: "none",
    },
  },

  link: {
    display: "block",
    lineHeight: 1,
    padding: "8px 12px",
    borderRadius: theme.radius.sm,
    textDecoration: "none",
    color:
      theme.colorScheme === "dark"
        ? theme.colors.dark[0]
        : theme.colors.gray[7],
    fontSize: theme.fontSizes.sm,
    fontWeight: 500,

    "&:hover": {
      backgroundColor:
        theme.colorScheme === "dark"
          ? theme.colors.dark[6]
          : theme.colors.gray[0],
    },
  },

  linkLabel: {
    marginRight: 5,
  },
  
  inductionText: {
    display: "block",
    fontWeight: 600,
    fontSize: theme.fontSizes.xl,
    textTransform: "uppercase",
    color: "white",               
    whiteSpace: "nowrap",
    [theme.fn.smallerThan("sm")]: {
       display: "none",
    },
  },

}));

export function NavbarComp() {
  // const matches = useMediaQuery("(max-width: 500px)");
  const { classes } = useStyles();
  const [loggedIn, setLoggedIn] = useState(false);
  const year=process.env.REACT_APP_CURRENT_YEAR;
  useEffect(() => {
    const checkUserExists = async () => {
      try {
        if (localStorage.getItem("token")) {
          const res = await fetchUserApi();
          // console.log(res);
          if (res.status == 200 && res.data.user.isProfileConfirmed==true) setLoggedIn(true);
        }
      } catch (err) {
        console.error(err);
        setLoggedIn(false);
      }
    };
    checkUserExists();
  }, []);
  return (
    <Header
      style={{ background: "transparent", marginTop: "20px" }}
      height={HEADER_HEIGHT}
      sx={{ borderBottom: 0 }}
    >
      <Container className={classes.inner} fluid>
        {/* <Group>
          <Burger
            opened={opened}
            onClick={() => toggleOpened()}
            className={classes.burger}
            size="sm"
          />
        </Group> */}
        <div style={{ display: "flex", alignItems: "center", gap: "1rem" }}>
            <picture>
                <img src="./Spider-Logo.svg" alt="spider" />
            </picture>

            <span className={classes.inductionText}>Spider Inductions {year}</span>
        </div>
        {/* <picture>
          <source
            media="(min-width:900px)"
            srcSet="./logo_induction_24.svg"
            id="spider_logo"
          />
          <img src="./Spider-Logo.svg" alt="spider" />
        </picture> */}
        {/* {matches ? (
          <img
            src="./Spider-Logo.svg"
            width={40}
            // height={"32px"}
            alt="spider-logo"
            // id="spider_logo"
          />
        ) : (
          <img src="./si22_logo.svg" alt="spider-logo" id="spider_logo" />
        )} */}

        <div className="nav-container">
          <a href="#about" className="nav-link">
            ABOUT
          </a>
          <a href="#profiles" className="nav-link">
            PROFILES
          </a>
          <a href="#faq" className="nav-link">
            FAQ
          </a>
          {loggedIn ? (
            <Link style={{ zIndex: 5 }} to="/dashboard/announcements">
              <button id="loginBtn">DASHBOARD</button>
            </Link>
          ) : (
            <Login />
          )}
          {/* <OTPModal /> */}
          {/* </div> */}
        </div>
      </Container>
    </Header>
  );
}